/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export type EntityTypeEnum = 'DEPLOYMENT' | 'ORG';

export const EntityTypeEnum = {

    DEPLOYMENT: 'DEPLOYMENT' as EntityTypeEnum,

    ORG: 'ORG' as EntityTypeEnum
};

